export default __webpack_public_path__ + "static/media/45t.36f51c56.jpg";